import type { ReactElement } from 'react';
import { ButtonPreset } from '@/constants/componentPresets';
import { ColorType } from '@/theme/colors';
import { FontWeight } from '@/theme/typography';
import { Cbutton } from '../Cbutton';
import { Ctext } from '../Ctext';
import { Ctextinput, TextInputMode } from '../Ctextinput';
const EMAIL_SENDING_LABEL = 'Sending...';
const EMAIL_AUTH_LABEL = 'Authenticate via Email';
const EMAIL_PLACEHOLDER = 'identity@email.com';
const TEXT_ALIGN_CENTER = 'center';
const LOADING_OPACITY = 0.6;
const READY_OPACITY = 1;
enum EmailInputDataError {
    True = 'true',
    False = 'false'
}
interface InitialEmailSectionProps {
    email: string;
    emailInputError: string;
    loadingApple: boolean;
    loadingGoogle: boolean;
    loadingEmail: boolean;
    onEmailAuth: () => void;
    onEmailChange: (value: string) => void;
}
interface EmailSectionViewModelInput {
    emailInputError: string;
    loadingApple: boolean;
    loadingGoogle: boolean;
    loadingEmail: boolean;
}
interface EmailSectionViewModel {
    dataError: EmailInputDataError;
    disabled: boolean;
    isError: boolean;
    placeholder: string;
    buttonLabel: string;
    buttonOpacity: number;
}
function getEmailInputDataError(hasError: boolean): EmailInputDataError {
    if (hasError)
        return EmailInputDataError.True;
    return EmailInputDataError.False;
}
function getEmailPlaceholder(emailInputError: string): string {
    if (emailInputError)
        return emailInputError;
    return EMAIL_PLACEHOLDER;
}
function getEmailButtonLabel(isLoading: boolean): string {
    if (isLoading)
        return EMAIL_SENDING_LABEL;
    return EMAIL_AUTH_LABEL;
}
function getEmailButtonOpacity(isLoading: boolean): number {
    if (isLoading)
        return LOADING_OPACITY;
    return READY_OPACITY;
}
function buildEmailSectionViewModel({ emailInputError, loadingApple, loadingGoogle, loadingEmail, }: EmailSectionViewModelInput): EmailSectionViewModel {
    const hasError = Boolean(emailInputError);
    return {
        dataError: getEmailInputDataError(hasError),
        disabled: [loadingEmail, loadingApple, loadingGoogle].some(Boolean),
        isError: hasError,
        placeholder: getEmailPlaceholder(emailInputError),
        buttonLabel: getEmailButtonLabel(loadingEmail),
        buttonOpacity: getEmailButtonOpacity(loadingEmail),
    };
}
export function InitialEmailSection({ email, emailInputError, loadingApple, loadingGoogle, loadingEmail, onEmailAuth, onEmailChange, }: InitialEmailSectionProps): ReactElement {
    const viewModel = buildEmailSectionViewModel({
        emailInputError,
        loadingApple,
        loadingGoogle,
        loadingEmail,
    });
    return (
      <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            width: '100%',
        }}>
        <div className="cauthmodal-email-input-wrapper" data-error={viewModel.dataError} style={{
            width: '100%',
            textAlign: 'center',
        }}>
          <Ctextinput dataElScope="Cauthmodal/InitialEmailSection" mode={TextInputMode.Textual} placeholder={viewModel.placeholder} value={email} onChange={onEmailChange} disabled={viewModel.disabled} isError={viewModel.isError} textAlign={TEXT_ALIGN_CENTER} style={{ width: '100%' }}/>
        </div>

        <Cbutton preset={ButtonPreset.Secondary} onClick={onEmailAuth} disabled={viewModel.disabled} style={{ width: '100%', opacity: viewModel.buttonOpacity }}>
          <Ctext size={16} weight={FontWeight.Medium} color={ColorType.White} opacity={1}>
            {viewModel.buttonLabel}
          </Ctext>
        </Cbutton>
      </div>
    );
}
